import { UserInfo } from '../../../../../models/getUserInfo/GetUserInfo'
import { PropertyFieldType } from '../../../../BotProperties/components/Properties/types'
import { SocketNames } from '../../components/Socket/SocketsHelper'

export default class FlowHelper {
  static UsersInfo: Array<UserInfo> = []

  static getPropertyIcon(type: PropertyFieldType): string {
    switch (type) {
      case PropertyFieldType.Date:
        return 'event'
      case PropertyFieldType.Double:
        return 'pin'
      case PropertyFieldType.Number:
        return 'pin'
      case PropertyFieldType.Email:
        return 'email'
      case PropertyFieldType.Phone:
        return 'phone_iphone'
      case PropertyFieldType.Time:
        return 'schedule'
      case PropertyFieldType.DateTime:
        return 'pending_actions'
      case PropertyFieldType.String:
        return 'text_fields'
      case PropertyFieldType.Flag:
        return 'flag'
      default:
        return ''
    }
  }

  static typeSocketColor(name: SocketNames | string): string {
    if (name === SocketNames.StartOutput || name === SocketNames.MainOutput || name === SocketNames.Default) {
      return '92, 173, 255'
    } else if (name === SocketNames.MainInput) {
      return 'orange'
    } else if (name === SocketNames.Success) {
      return '105, 183, 68'
    } else if (name === SocketNames.Fail) {
      return '247, 78, 87'
    } else if (name === SocketNames.Inactive) {
      return '211, 51, 255'
    }

    return ''
  }
}
